function vaThrottle(fn, threshhold, scope){
	threshhold || (threshhold = 250);
	var last,
		deferTimer;
	return function(){
		var context = scope || this;
		var now = +new Date,
			args = arguments;
		if (last && now < last + threshhold){
			// hold on to it
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function(){
				last = now;
				fn.apply(context, args);
			}, threshhold);
		} else {
			last = now;
			fn.apply(context, args);
		}
	};
}

(function(){
	'use strict';
	const vaClickyMenus = function(menu){
		let	container = menu.parentElement,
			currentMenuItem,
			i,
			len;
		this.init = function(){
			menuSetup();
			document.addEventListener('click', closeOpenMenu);
		}
		function toggleOnMenuClick(e){
			const button = e.currentTarget;
			// close open menu if there is one
			if (currentMenuItem && button !== currentMenuItem){
				toggleSubmenu(currentMenuItem);
			}
			toggleSubmenu(button);
		};
		function toggleSubmenu(button) {
			const submenu = document.getElementById( button.getAttribute('aria-controls'));
			if ('true' === button.getAttribute('aria-expanded')){
				button.setAttribute('aria-expanded', false);
				submenu.setAttribute('aria-hidden', true);
				currentMenuItem = false;
				document.getElementById('va-header').classList.remove('is-active');
			} else {
				button.setAttribute('aria-expanded', true);
				submenu.setAttribute('aria-hidden', false);
				currentMenuItem = button;
				document.getElementById('va-header').classList.add('is-active');
			}
		};
		function closeOnEscKey(e) {
			if (	27 === e.keyCode ){
				if ( null !== e.target.closest('.va-header__subnav[aria-hidden="false"]') ) {
					currentMenuItem.focus();
					toggleSubmenu(currentMenuItem);
				} else if ( 'true' === e.target.getAttribute('aria-expanded') ) {
					toggleSubmenu(currentMenuItem);
				}
			}
		}
		function closeOpenMenu(e){
		//	if ( currentMenuItem && ! e.target.closest('#' + container.id)){
		//		toggleSubmenu(currentMenuItem);
		//	}
		};
		function menuSetup(){
			menu.classList.remove('va-clicky-menu-no-js');
			menu.querySelectorAll('.va-header__subnav').forEach((submenu) => {
				const menuItem = submenu.parentElement;
				if ('undefined' !== typeof submenu){
					let button = convertLinkToButton(menuItem);
					setUpAria(submenu, button);
					// bind event listener to button
					button.addEventListener('click', toggleOnMenuClick);
					menu.addEventListener('keyup', closeOnEscKey);
				}
			});
		};
		function convertLinkToButton(menuItem){
			const 	link = menuItem.getElementsByTagName('a')[0],
					linkHTML = link.innerHTML,
					linkAtts = link.attributes,
					button = document.createElement('button');
			if (null !== link){
				// copy button attributes and content from link
				button.innerHTML = linkHTML.trim();
				for (i = 0, len = linkAtts.length; i < len; i++){
					let attr = linkAtts[i];
					if('href' !== attr.name){
						button.setAttribute(attr.name, attr.value);
					}
				}
				menuItem.replaceChild(button, link);
			}
			return button;
		}
		function setUpAria(submenu, button){
			const submenuId = submenu.getAttribute('id');
			let id;
			if( null === submenuId ) {
				id = button.textContent.trim().replace(/\s+/g, '-').toLowerCase() + '-submenu';
			} else {
				id = menuItemId + '-submenu';
			}
			button.setAttribute('aria-controls', id);
			button.setAttribute('aria-expanded', false);
			submenu.setAttribute('id', id);
			submenu.setAttribute('aria-hidden', true);
		}
	}

	/* Create a ClickMenus object and initiate menu for any menu with .va-clicky-menu class */
	document.addEventListener('DOMContentLoaded', function(){
		const va_menus = document.querySelectorAll('.va-clicky-menu');
		va_menus.forEach(va_menu => {
			let vaClickyMenu = new vaClickyMenus(va_menu);
			vaClickyMenu.init();
		});
	});
}());

function vaCloseHeaderSubnavs(){
	var clicky_menu_subnavs = document.querySelectorAll('.va-clicky-menu .va-header__subnav[aria-hidden="false"]');
	var clicky_menu_triggers = document.querySelectorAll('.va-clicky-menu .va-header__nav__primarylink[aria-expanded="true"]');
	for (var i=0; i<clicky_menu_subnavs.length; i++){
		clicky_menu_subnavs[i].setAttribute('aria-hidden', true);
	}
	for (var i=0; i<clicky_menu_triggers.length; i++){
		clicky_menu_triggers[i].setAttribute('aria-expanded', false);
	}
	va_header.classList.remove('is-active');
}

function vaHandleMediaQueryChange(e){
	if (e.matches) {
		va_header_nav.setAttribute('aria-hidden', 'true');
	} else {
		va_header_nav.setAttribute('aria-hidden', 'false');
		va_header_toggle.setAttribute('aria-expanded', 'false');
		va_doc.classList.remove('va-static-cover');
	}
}

function vaWindowScroll(){
	if (window.scrollY > 0){
		document.getElementById('va-header').classList.add('is-scrolled');
	} else {
		document.getElementById('va-header').classList.remove('is-scrolled');
	}
}

var va_doc = document.documentElement,
	va_header = document.getElementById('va-header'),
	va_header_nav = document.getElementById('va-header-nav'),
	va_header_toggle = document.querySelector('[data-va-header-toggle]'),
	va_mobile_mediaquery = window.matchMedia('(max-width: 1180px)'),
	va_searchdrawer = document.getElementById('va-searchdrawer'),
	va_searchdrawer_closers = document.querySelectorAll('[data-va-searchdrawer-closer]'),
	va_searchdrawer_trigger = document.querySelector('[data-va-searchdrawer-trigger]');

document.onreadystatechange = function (){
	if (document.readyState == "interactive"){
		
		window.addEventListener('scroll', vaThrottle(vaWindowScroll, 100));
		
		document.getElementById('MainContent').addEventListener('click', function(e){ vaCloseHeaderSubnavs(); });
		document.getElementById('shopify-section-footer').addEventListener('click', function(e){ vaCloseHeaderSubnavs(); });
		
		va_mobile_mediaquery.addListener(vaHandleMediaQueryChange);
		vaHandleMediaQueryChange(va_mobile_mediaquery);
		
		va_header_toggle.addEventListener('click', function(e){
			var expanded = this.getAttribute('aria-expanded');
			if (expanded == "true"){
				expanded = "false";
				va_header_nav.setAttribute('aria-hidden', 'true');
				va_doc.classList.remove('va-static-cover');
			} else {
				expanded = "true";
				va_header_nav.setAttribute('aria-hidden', 'false');
				va_doc.classList.add('va-static-cover');
			}
			this.setAttribute('aria-expanded', expanded);
		});
		
		for (var i=0; i<va_searchdrawer_closers.length; i++){
			var elem = va_searchdrawer_closers[i];
			elem.addEventListener('click', function(e){
				va_searchdrawer.classList.remove('active');
			});
		}
		
		va_searchdrawer_trigger.addEventListener('click', function(e){
			va_searchdrawer.classList.add('active');
		});
		
		document.onkeydown = function(e) {
			e = e || window.event;
			var is_escape = false;
			if ("key" in e) {
				is_escape = (e.key === "Escape" || e.key === "Esc");
			} else {
				is_escape = (e.keyCode === 27);
			}
			if (is_escape) {
				va_searchdrawer.classList.remove('active');
			}
		};
		
		
	}
}
